<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  import MutedInfoText from "./MutedInfoText.svelte";
  import NewOrderTile from "./NewOrderTile.svelte";
  import OrderTile from "./OrderTile.svelte";

  export let orders;
  export let orderFrames;

  function getOrders(orderFrameId) {
    return orders.filter((el) => el.orderFrame == orderFrameId);
  }

  function addZero(numb) {
    return numb < 10 ? "0" + numb : numb;
  }

  function timestampToDate(timestamp) {
    let dateObj = new Date(timestamp * 1000);
    return `${addZero(dateObj.getDate())}.${addZero(dateObj.getMonth() + 1)}.`;
  }
</script>

{#each orderFrames as orderFrame}
  {#if new Date() > orderFrame.availableBegin * 1000 && new Date() < orderFrame.availableEnd * 1000}
    <div class="orderFrameContainer active animate__fadeInUp animate__animated" class:tooManyItems={getOrders(orderFrame.id).length >= 4}>
      <div class="containerInfo">
        <p class="title">LIEFERZEITRAUM</p>
        <p class="weekNo">
          KW {addZero(orderFrame.weekNoBegin)} - KW {addZero(
            orderFrame.weekNoEnd
          )}
        </p>
        <p class="dates">
          {timestampToDate(orderFrame.dateBegin)} - {timestampToDate(
            orderFrame.dateEnd
          )}
        </p>
      </div>
      <div class="frameContainer">
        <div class="boxContainer">
          <NewOrderTile orderFrameId={orderFrame.id} />
          {#each getOrders(orderFrame.id) as order}
            <OrderTile {order} />
          {/each}
        </div>
        {#if getOrders(orderFrame.id).length == 0}
          <MutedInfoText
            text={"Für diesen Lieferzeitraum liegen noch keine Bestellungen von dir vor."}
          />
        {/if}
      </div>
    </div>
  {:else if new Date() < orderFrame.availableBegin * 1000}
    <div
      class="orderFrameContainer unavailable animate__fadeInUp animate__animated"
    >
      <div class="containerInfo">
        <p class="title">LIEFERZEITRAUM</p>
        <p class="weekNo">
          KW {addZero(orderFrame.weekNoBegin)} - KW {addZero(
            orderFrame.weekNoEnd
          )}
        </p>
        <p class="dates">
          {timestampToDate(orderFrame.dateBegin)} - {timestampToDate(
            orderFrame.dateEnd
          )}
        </p>
      </div>
      <div class="frameContainer">
        <div class="boxContainer" />
        <MutedInfoText
          text={`Für diesen Lieferzeitraum kannst du ab dem ${timestampToDate(
            orderFrame.availableBegin
          )} Bestellungen aufgeben.`}
        />
      </div>
    </div>
  {/if}
{/each}

<style>
  .orderFrameContainer:nth-child(2) {
    animation-delay: 0.15s;
  }
  .orderFrameContainer:nth-child(3) {
    animation-delay: 0.3s;
  }
  .orderFrameContainer:nth-child(4) {
    animation-delay: 0.45s;
  }
  .orderFrameContainer:nth-child(5) {
    animation-delay: 0.6s;
  }

  .orderFrameContainer {
    min-height: 160px;
    margin: 15px 0;
    border-radius: 10px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    transition: box-shadow 0.25s ease-in-out, transform 0.1s ease-in-out;
    flex-wrap: wrap;
  }

  .orderFrameContainer.active {
    background: #fff;
    background-image: url(/assets/img/milkSplashBackgroundBlue_long.svg);
    background-repeat: no-repeat;
    background-position: -215px 0;
  }

  .orderFrameContainer.unavailable {
    cursor: not-allowed;
    background: #e4e6e7;
    background-image: url(/assets/img/milkSplashBackgroundGray_long.svg);
    background-repeat: no-repeat;
    background-position: -215px 0;
  }

  .frameContainer {
    flex-grow: 4;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 110px;
    flex-wrap: nowrap;
  }
  .boxContainer {
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .orderFrameContainer > .containerInfo {
    cursor: default;
    color: #676767;
    text-align: left;
    line-height: 22px;
    padding: 20px;
    transition: color 0.1s ease-in-out;
  }
  .orderFrameContainer.unavailable > .containerInfo {
    cursor: not-allowed;
  }

  .orderFrameContainer.active > .containerInfo {
    color: #fff;
  }

  .containerInfo > p {
    margin-bottom: 0;
  }
  .containerInfo > p.title {
    text-align: left;
    padding-bottom: 10px;
    font-size: 12px;
    font-weight: bolder;
  }
  .containerInfo > p.weekNo {
    font-size: 28px;
    font-weight: bolder;
  }
  .containerInfo > p.dates {
    font-size: 16px;
  }

  .orderFrameContainer.tooManyItems {
    background-image: none !important;
  }
  .orderFrameContainer.tooManyItems > .containerInfo {
    color: #676767 !important;
  }

  @media screen and (max-width: 1400px) {
    .orderFrameContainer {
      background-image: none !important;
    }
    .orderFrameContainer > .containerInfo {
      color: #676767 !important;
    }
    .frameContainer {
      margin-left: 50px;
      flex-wrap: wrap;
    }
  }

  @media screen and (max-width: 992px) {
    .boxContainer {
      width: 100%;
    }
  }

  @media screen and (max-width: 500px) {
    .frameContainer {
      margin-left: 0;
    }
  }
</style>
